/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import {
	appBundleReadyMark,
	prefetchApiReadyMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import AddProjectToHistory from '@atlassian/jira-spa-apps-common/src/add-project-to-history/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { getIsSoftwareThemingM2Enabled } from '@atlassian/jira-project-theme-providers/src/utils/getIsSoftwareThemingEnabled.tsx';
import { pagesOverrideStyles } from '@atlassian/jira-project-theme-page-container/src/common/utils.tsx';
import { projectPagesPageLoad } from '../utils/performance-analytics/index.tsx';
import type { Props } from './types.tsx';

const pageLayoutStyles = css({
	height: '100%',
	marginTop: 0,
	marginRight: token('space.500'),
	marginBottom: 0,
	marginLeft: token('space.500'),
});

function ProjectPages(props: Props) {
	const { Updater, ProjectPagesApp, tenantContext, projectContext } = props;

	if (!(projectContext && projectContext.data && projectContext.data.projectKey)) {
		return null;
	}

	const { isAdmin, isSiteAdmin, baseUrl, locale, cloudId, atlassianAccountId, environment } =
		tenantContext;

	const { projectId, projectKey, projectName, projectType } = projectContext.data;

	return (
		<div css={pageLayoutStyles}>
			<ReportErrors
				id="unhandled"
				packageName="jiraSpaAppsProjectPages"
				teamName="confluence-better-together"
			>
				<MarkProductStart />
				<Updater />
				<ProjectPagesApp
					baseUrl={baseUrl}
					locale={locale}
					isAdmin={isAdmin}
					isSiteAdmin={isSiteAdmin}
					cloudId={cloudId}
					accountId={atlassianAccountId}
					projectId={projectId}
					projectKey={projectKey}
					projectName={projectName}
					projectType={projectType}
					environment={environment}
					breadcrumbs={<BreadcrumbRenderer />}
					{...(getIsSoftwareThemingM2Enabled() && {
						theme: pagesOverrideStyles({
							name: 'projectPages',
							type: 'projectPages',
						}),
					})}
				/>
				{/* @ts-expect-error - TS2769 - No overload matches this call. */}
				<SubmitApdex
					metricKey="jira.project.pages"
					metric={projectPagesPageLoad}
					isExpectedToHaveSsr
					withMarks={[appBundleReadyMark, prefetchApiReadyMark]}
				/>
				<AddProjectToHistory baseUrl={baseUrl} projectKey={projectKey} />
				<SpaStatePageReady />
			</ReportErrors>
		</div>
	);
}
export default AnalyticsSource('project-pages', SCREEN)(ProjectPages);
